 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {HocuspocusProvider, HocuspocusProviderWebsocket} from '@hocuspocus/provider'
import {IndexeddbPersistence} from 'y-indexeddb'
import * as Y from 'yjs'


class ProviderManager {constructor() { ProviderManager.prototype.__init.call(this);ProviderManager.prototype.__init2.call(this); }
  __init() {this.socket = undefined}
  __init2() {this.providers


 = {}}
  
  setAtmosphere(atmosphere) {
    this.atmosphere = atmosphere
  }
  getSocket() {
    if (!this.socket) {
      const wsProtocol = window.location.protocol.replace('http', 'ws')
      const url = `${wsProtocol}//${window.location.host}/yjs`
      this.socket = new HocuspocusProviderWebsocket({
        url
      })
    }
    return this.socket
  }
  use(documentName) {
    const existing = this.providers[documentName]
    if (existing) {
      existing.count++
      return existing.provider
    }
    return null
  }
  register(documentName) {
    const existing = this.use(documentName)
    if (existing) return existing
    const doc = new Y.Doc()
    // update the URL to match the title
    const provider = new HocuspocusProvider({
      websocketProvider: this.getSocket(),
      name: documentName,
      document: doc,
      // can remove after debugging server websocket auth on hocuspocus
      token: window.document.cookie,
      onAuthenticationFailed: ({reason}) => {
        console.log('fail', reason)
        if (reason === 'Unauthorized') {
          const entry = this.providers[documentName]
          if (entry) {
            _optionalChain([entry, 'access', _ => _.persistence, 'optionalAccess', _2 => _2.destroy, 'call', _3 => _3()])
            entry.persistence = undefined
          }
        }
        if (reason === 'InvalidDocument') {
          // The documentName they passed in cannot exist (DBID out of bounds)
          window.indexedDB.deleteDatabase(documentName)
          window.location.href = '/'
        }
        if (reason === 'Unauthenticated') {
          _optionalChain([this, 'access', _4 => _4.atmosphere, 'optionalAccess', _5 => _5.invalidateSession, 'call', _6 => _6(reason)])
        }
      }
    })
    provider.attach()
    this.providers[documentName] = {count: 1, provider}
    if (documentName.startsWith('page:')) {
      provider.on('authenticated', ({scope}) => {
        const entry = this.providers[documentName]
        if (!entry) return
        if (scope === 'readonly') {
          _optionalChain([entry, 'access', _7 => _7.persistence, 'optionalAccess', _8 => _8.destroy, 'call', _9 => _9()])
          entry.persistence = undefined
        } else if (!entry.persistence) {
          entry.persistence = new IndexeddbPersistence(documentName, doc)
        }
      })
    }
    return provider
  }
  unregister(documentName, delay = 10000) {
    const prevProviderEntry = this.providers[documentName]
    if (!prevProviderEntry) return
    if (--prevProviderEntry.count === 0) {
      setTimeout(() => {
        this.destroy(documentName)
      }, delay)
    }
  }

  async withDoc(
    documentName,
    callbackFn
  ) {
    const provider = this.register(documentName)
    const callAndComplete = async () => {
      await callbackFn(provider)
      this.unregister(documentName)
    }
    if (provider.synced) {
      callAndComplete()
    } else {
      provider.on('synced', callAndComplete)
    }
  }

  destroy(documentName) {
    const prevProviderEntry = this.providers[documentName]
    if (!prevProviderEntry) return
    if (prevProviderEntry.count === 0) {
      prevProviderEntry.provider.destroy()
      delete this.providers[documentName]
    }
  }

  close() {
    const entries = Object.values(this.providers)
    this.providers = {}
    entries.forEach((e) => e.provider.destroy())
    // fire-and-forget: clearData is best-effort before the page redirects
    void Promise.all(entries.map((e) => _optionalChain([e, 'access', _10 => _10.persistence, 'optionalAccess', _11 => _11.clearData, 'call', _12 => _12()]))).then(() => {
      void indexedDB.databases().then((dbs) => {
        dbs.forEach(({name}) => {
          if (_optionalChain([name, 'optionalAccess', _13 => _13.startsWith, 'call', _14 => _14('page:')])) indexedDB.deleteDatabase(name)
        })
      })
    })
  }
}

export const providerManager = new ProviderManager()
